/**
 * Safe rendering utilities to prevent React error #31
 * (Objects are not valid as a React child)
 */

import React from "react";

export function safeText(x: unknown, fallback = ""): string {
  if (x == null) return fallback;
  if (typeof x === "string" || typeof x === "number" || typeof x === "boolean") return String(x);
  if (x instanceof Error) return x.message || fallback;
  if (Array.isArray(x)) return x.map(v => safeText(v, "")).join(", ");
  try { 
    return JSON.stringify(x); 
  } catch { 
    return String(x); 
  }
}

/**
 * Safely sanitizes React.ReactNode to prevent rendering plain objects
 * Converts any non-valid React children (objects, functions, symbols) to safe text
 */
export function safeNode(node: React.ReactNode): React.ReactNode {
  if (node == null) return node;
  if (typeof node === "string" || typeof node === "number" || typeof node === "boolean") return node;
  if (Array.isArray(node)) return node.map(safeNode) as any;
  if (React.isValidElement(node)) return node;
  // Qualsiasi plain object / function / symbol ecc: converto a testo
  return safeText(node);
}

